module.exports = __webpack_public_path__ + "img/null_chapter.c38f8251.png";